import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AppService } from 'app/app.service';
import { AuthService } from 'app/services';
import { filter, firstValueFrom } from 'rxjs';

// canMatch runs before the route's canActivate guards, and on a reload only authenticatedGuard (a
// canActivate guard) loads the client. Without restoring the session here first, this guard would
// wait forever for a client that only a later guard can load.
export const radUiGuard: CanMatchFn = async (_route, segments) => {
    const appService = inject(AppService);
    const authService = inject(AuthService);
    const router = inject(Router);

    const url = router.currentNavigation()?.extractedUrl.toString() ?? `/${segments.map(segment => segment.path).join('/')}`;
    let result = false;
    if (await authService.isAuthenticated(url)) {
        await firstValueFrom(appService.client$.pipe(filter(client => !!client)));
        result = appService.flags.radUIEnabled();
    }
    return result;
};
